<template>
  <div class="InputWrapper" :class="{ '!bg-gray-100 dark:!bg-gray-600': disabled }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.InputWrapper {
  @apply bg-white flex flex-row flex-nowrap items-center w-full border-gray-300 hover:border-gray-400 focus-visible:shadow-md focus-within:!border-primary rounded border border-solid gap-2 py-2 px-2;
}

.dark .InputWrapper {
  @apply bg-gray-700 border-gray-600 hover:border-gray-500;
}

.InputWrapper input {
  @apply text-gray-700 placeholder-gray-300 w-full;
}

.dark .InputWrapper input {
  @apply text-gray-200 placeholder-gray-500 bg-transparent;
}

.lg .InputWrapper {
  @apply !text-2xl !py-3 !gap-4 !px-4;
}
</style>
